// This file is generated by scripts/write-app-version.js.
export const APP_VERSION = "0.1.9";
export const APP_COMMIT_SHA = "efa5c9e";
